<div class="forecast-wrapper">
  <!-- <app-user-section-access [sectionName]="guardSection()">
    <ng-template> -->
  @if (isGranted()) {
    @if ((companyFacade.isExistForecastInfo$ | async) === true) {
      <div class="app-company-info">
        <app-company-header-card
          [guardSectionName]="routerFacade.guardSectionName$ | async"
          [showHomePageLink]="(companyFacade.isShowCancelOption$ | async) === true"
          [forecast]="companyFacade.forecast$ | async"
        ></app-company-header-card>

        <div class="mat-tab-nav-bar-wrapper">
          <div class="mat-tab-nav-bar-block">
            <nav mat-tab-nav-bar mat-stretch-tabs="false" mat-align-tabs="start" [tabPanel]="tabPanel">
              @for (link of TAB_LINKS; track link) {
                <a
                  mat-tab-link
                  queryParamsHandling="merge"
                  [routerLink]="link.link"
                  routerLinkActive
                  #rla="routerLinkActive"
                  [active]="rla.isActive"
                >
                  {{ link.label | translate }}
                </a>
              }
            </nav>
            <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
          </div>
        </div>

        <router-outlet></router-outlet>
      </div>
    }
    @if ((companyFacade.isExistForecastInfo$ | async) === false && (inRequest$ | async) === false) {
      <app-forecast-not-found></app-forecast-not-found>
    }
  } @else {
    <div class="not-granted-block">
      <mat-icon>lock</mat-icon>
    </div>
  }
  <!-- </ng-template>
  </app-user-section-access> -->
</div>
